import { render, staticRenderFns } from "./SelectedItmDetail.vue?vue&type=template&id=51c53e14&scoped=true&"
import script from "./SelectedItmDetail.vue?vue&type=script&lang=js&"
export * from "./SelectedItmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c53e14",
  null
  
)

export default component.exports